const nerves_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },
  
   {
      "question":"Does ##name## have ##redHeading## attributable to diabetic peripheral neuropathy?",
      "redHeading": "constant pain",
      "sub":"Constant pain (may be excruciating at times)",
      "type":"select",
      "show": true,
      "section": {
         page: "2",
         title: "Symptoms",
         number: "3A"
      },
      "questions":[
         {
            "label":"Constant Pain",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "dbqName": "F[0].#subform[1].Constant[0],F[0].#subform[1].Yes2a[0]",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].ConstantUpperR[0],F[0].#subform[1].ConstantUpperR[1],F[0].#subform[1].ConstantUpperR[2],F[0].#subform[1].ConstantUpperR[3]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].ConstantLowerR[3],F[0].#subform[1].ConstantLowerR[2],F[0].#subform[1].ConstantLowerR[1],F[0].#subform[1].ConstantLowerR[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },
         {
            "label":"Constant Pain",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].ConstantUpperL[3],F[0].#subform[1].ConstantUpperL[2],F[0].#subform[1].ConstantUpperL[1],F[0].#subform[1].ConstantUpperL[0]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].ConstantLowerL[3],F[0].#subform[1].ConstantLowerL[2],F[0].#subform[1].ConstantLowerL[1],F[0].#subform[1].ConstantLowerL[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },         
      ]
   },
   {
      "question":"Does ##name## have ##redHeading## attributable to diabetic peripheral neuropathy?",
      "redHeading": "intermittent pain",
      "sub":"Intermittent pain (Usually dull)",
      "type":"select",
      "show": true,
      "questions":[
         {
            "label":"Intermittent Pain",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "dbqName": "F[0].#subform[1].Intermittent[0],F[0].#subform[1].Yes2a[0]",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].IntermittentUpperR[0],F[0].#subform[1].IntermittentUpperR[1],F[0].#subform[1].IntermittentUpperR[2],F[0].#subform[1].IntermittentUpperR[3]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].IntermittentLowerR[3],F[0].#subform[1].IntermittentLowerR[2],F[0].#subform[1].IntermittentLowerR[1],F[0].#subform[1].IntermittentLowerR[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },
         {
            "label":"Intermittent Pain",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].IntermittentUpperL[3],F[0].#subform[1].IntermittentUpperL[2],F[0].#subform[1].IntermittentUpperL[1],F[0].#subform[1].IntermittentUpperL[0]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].IntermittentLowerL[3],F[0].#subform[1].IntermittentLowerL[2],F[0].#subform[1].IntermittentLowerL[1],F[0].#subform[1].IntermittentLowerL[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },         
      ]
   },
   {
      "question":"Does ##name## have ##redHeading## attributable to diabetic peripheral neuropathy?",
      "redHeading": "paresthesias and/or dysesthesias",
      "sub":"",
      "type":"select",
      "show": true,
      "questions":[
         {
            "label":"Paresthesias and/or Dysesthesias",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "dbqName": "F[0].#subform[1].Yes2a[0],F[0].#subform[1].Paresthesias[0]",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].ParesthesiasUpperR[0],F[0].#subform[1].ParesthesiasUpperR[1],F[0].#subform[1].ParesthesiasUpperR[2],F[0].#subform[1].ParesthesiasUpperR[3]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].ParesthesiasLowerR[3],F[0].#subform[1].ParesthesiasLowerR[2],F[0].#subform[1].ParesthesiasLowerR[1],F[0].#subform[1].ParesthesiasLowerR[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },
         {
            "label":"Paresthesias and/or Dysesthesias",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].ParesthesiasUpperL[3],F[0].#subform[1].ParesthesiasUpperL[2],F[0].#subform[1].ParesthesiasUpperL[1],F[0].#subform[1].ParesthesiasUpperL[0]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].ParesthesiasLowerL[3],F[0].#subform[1].ParesthesiasLowerL[2],F[0].#subform[1].ParesthesiasLowerL[1],F[0].#subform[1].ParesthesiasLowerL[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },         
      ]
   },
   {
      "question":"Does ##name## have ##redHeading## attributable to diabetic peripheral neuropathy?",
      "redHeading": "numbness",
      "sub":"",
      "type":"select",
      "show": true,
      "questions":[
         {
            "label":"Numbness",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "dbqName":"F[0].#subform[1].Yes2a[0],F[0].#subform[1].Numbness[0]",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].NumbnessUpperR[0],F[0].#subform[1].NumbnessUpperR[1],F[0].#subform[1].NumbnessUpperR[2],F[0].#subform[1].NumbnessUpperR[3]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].NumbnessLowerR[3],F[0].#subform[1].NumbnessLowerR[2],F[0].#subform[1].NumbnessLowerR[1],F[0].#subform[1].NumbnessLowerR[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },
         {
            "label":"Numbness",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "None",
                  "dbqName": "F[0].#subform[1].NumbnessUpperL[3],F[0].#subform[1].NumbnessUpperL[2],F[0].#subform[1].NumbnessUpperL[1],F[0].#subform[1].NumbnessUpperL[0]",
                  "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "None",
                 "dbqName":  "F[0].#subform[1].NumbnessLowerL[3],F[0].#subform[1].NumbnessLowerL[2],F[0].#subform[1].NumbnessLowerL[1],F[0].#subform[1].NumbnessLowerL[0]",
                 "values":[
                     "None",
                     "Mild",
                     "Moderate",
                     "Severe"
                  ],
                  "answer":"None"
               },
            ]
         },         
      ]
   },

   {
      "question":"Rate muscle movement strength",
      "sub":"",
      "type":"select",
      "show": true,
      "section": {
         page: "3",
         title: "NEUROLOGIC EXAM",
         number: "4A"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Elbow Flexion",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "5",
                  "dbqName":"F[0].Page_2[0].ElbowFlexionR_0[0],F[0].Page_2[0].ElbowFlexionR_1[0],F[0].Page_2[0].ElbowFlexionR_2[0],F[0].Page_2[0].ElbowFlexionR_3[0],F[0].Page_2[0].ElbowFlexionR_4[0],F[0].Page_2[0].ElbowFlexionR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                 "main":"Elbow Extension",
                 "sub":"",
                 "type":"check",
                "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].ElbowExtensionR_0[0],F[0].Page_2[0].ElbowExtensionR_1[0],F[0].Page_2[0].ElbowExtensionR_2[0],F[0].Page_2[0].ElbowExtensionR_3[0],F[0].Page_2[0].ElbowExtensionR_4[0],F[0].Page_2[0].ElbowExtensionR_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
               },
               {
                 "main":"Wrist Flexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].WristFlexionR_0[0],F[0].Page_2[0].WristFlexionR_1[0],F[0].Page_2[0].WristFlexionR_2[0],F[0].Page_2[0].WristFlexionR_3[0],F[0].Page_2[0].WristFlexionR_4[0],F[0].Page_2[0].WristFlexionR_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
               },
               {
                "main":"Wrist Extension",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].WristExtensionR_0[0],F[0].Page_2[0].WristExtensionR_1[0],F[0].Page_2[0].WristExtensionR_2[0],F[0].Page_2[0].WristExtensionR_3[0],F[0].Page_2[0].WristExtensionR_4[0],F[0].Page_2[0].WristExtensionR_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
               },
               {
                  "main":"Grip",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].GripR_0[0],F[0].Page_2[0].GripR_1[0],F[0].Page_2[0].GripR_2[0],F[0].Page_2[0].GripR_3[0],F[0].Page_2[0].GripR_4[0],F[0].Page_2[0].GripR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                 "main":"Pinch (thumb to index finger)",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].PinchR_0[0],F[0].Page_2[0].PinchR_1[0],F[0].Page_2[0].PinchR_2[0],F[0].Page_2[0].PinchR_3[0],F[0].Page_2[0].PinchR_4[0],F[0].Page_2[0].PinchR_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
               },
               {
                  "main":"Knee Extension",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":"F[0].Page_2[0].KneeR_0[0],F[0].Page_2[0].KneeR_1[0],F[0].Page_2[0].KneeR_2[0],F[0].Page_2[0].KneeR_3[0],F[0].Page_2[0].KneeR_4[0],F[0].Page_2[0].KneeR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Knee Flexion",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":"F[0].Page_2[0].KneeR_0[1],F[0].Page_2[0].KneeR_1[1],F[0].Page_2[0].KneeR_2[1],F[0].Page_2[0].KneeR_3[1],F[0].Page_2[0].KneeR_4[1],F[0].Page_2[0].KneeR_5[1]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Ankle Plantar Flexion",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":   "F[0].Page_2[0].PlantarR_0[0],F[0].Page_2[0].PlantarR_1[0],F[0].Page_2[0].PlantarR_2[0],F[0].Page_2[0].PlantarR_3[0],F[0].Page_2[0].PlantarR_4[0],F[0].Page_2[0].PlantarR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Ankle Dorsiflexion",
                  "sub":"",
                  "type":"check",
                 "defaultVal": "5",
                  "dbqName":   "F[0].Page_2[0].AnkleR_0[0],F[0].Page_2[0].AnkleR_1[0],F[0].Page_2[0].AnkleR_2[0],F[0].Page_2[0].AnkleR_3[0],F[0].Page_2[0].AnkleR_4[0],F[0].Page_2[0].AnkleR_5[0]",
                  "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ],
                  "answer":"5"
               },
            ]
         },
         {
           "label":"Flexion/Extension",
           "title":"Left Side",
           "subMain":"Rate Strength",
           "sub":"",
           "options":[
              {
                 "main":"Elbow Flexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].ElbowFlexionL_0[0],F[0].Page_2[0].ElbowFlexionL_1[0],F[0].Page_2[0].ElbowFlexionL_2[0],F[0].Page_2[0].ElbowFlexionL_3[0],F[0].Page_2[0].ElbowFlexionL_4[0],F[0].Page_2[0].ElbowFlexionL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                "main":"Elbow Extension",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                "dbqName":  "F[0].Page_2[0].ElbowExtensionL_0[0],F[0].Page_2[0].ElbowExtensionL_1[0],F[0].Page_2[0].ElbowExtensionL_2[0],F[0].Page_2[0].ElbowExtensionL_3[0],F[0].Page_2[0].ElbowExtensionL_4[0],F[0].Page_2[0].ElbowExtensionL_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
              },
              {
                "main":"Wrist Flexion",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                "dbqName":  "F[0].Page_2[0].WristFlexionL_0[0],F[0].Page_2[0].WristFlexionL_1[0],F[0].Page_2[0].WristFlexionL_2[0],F[0].Page_2[0].WristFlexionL_3[0],F[0].Page_2[0].WristFlexionL_4[0],F[0].Page_2[0].WristFlexionL_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
              },
              {
               "main":"Wrist Extension",
               "sub":"",
               "type":"check",
                 "defaultVal": "5",
               "dbqName":   "F[0].Page_2[0].WristExtensionL_0[0],F[0].Page_2[0].WristExtensionL_1[0],F[0].Page_2[0].WristExtensionL_2[0],F[0].Page_2[0].WristExtensionL_3[0],F[0].Page_2[0].WristExtensionL_4[0],F[0].Page_2[0].WristExtensionL_5[0]",
               "values":[
                 "0",
                 "1",
                 "2",
                 "3",
                 "4",
                 "5"
               ],
               "answer":"5"
              },
              {
                 "main":"Grip",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].GripL_0[0],F[0].Page_2[0].GripL_1[0],F[0].Page_2[0].GripL_2[0],F[0].Page_2[0].GripL_3[0],F[0].Page_2[0].GripL_4[0],F[0].Page_2[0].GripL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                "main":"Pinch (thumb to index finger)",
                "sub":"",
                "type":"check",
                 "defaultVal": "5",
                "dbqName":  "F[0].Page_2[0].PinchL_0[0],F[0].Page_2[0].PinchL_1[0],F[0].Page_2[0].PinchL_2[0],F[0].Page_2[0].PinchL_3[0],F[0].Page_2[0].PinchL_4[0],F[0].Page_2[0].PinchL_5[0]",
                "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                ],
                "answer":"5"
              },
              {
                 "main":"Knee Extension",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].KneeL_0[0],F[0].Page_2[0].KneeL_1[0],F[0].Page_2[0].KneeL_2[0],F[0].Page_2[0].KneeL_3[0],F[0].Page_2[0].KneeL_4[0],F[0].Page_2[0].KneeL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
               "main":"Knee Flexion",
               "sub":"",
               "type":"check",
              "defaultVal": "5",
               "dbqName":"F[0].Page_2[0].KneeL_0[1],F[0].Page_2[0].KneeL_1[1],F[0].Page_2[0].KneeL_2[1],F[0].Page_2[0].KneeL_3[1],F[0].Page_2[0].KneeL_4[1],F[0].Page_2[0].KneeL_5[1]",
               "values":[
                 "0",
                 "1",
                 "2",
                 "3",
                 "4",
                 "5"
               ],
               "answer":"5"
            },
              {
                 "main":"Ankle Plantar Flexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].PlantarL_0[0],F[0].Page_2[0].PlantarL_1[0],F[0].Page_2[0].PlantarL_2[0],F[0].Page_2[0].PlantarL_3[0],F[0].Page_2[0].PlantarL_4[0],F[0].Page_2[0].PlantarL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
              {
                 "main":"Ankle Dorsiflexion",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "5",
                 "dbqName": "F[0].Page_2[0].AnkleL_0[0],F[0].Page_2[0].AnkleL_1[0],F[0].Page_2[0].AnkleL_2[0],F[0].Page_2[0].AnkleL_3[0],F[0].Page_2[0].AnkleL_4[0],F[0].Page_2[0].AnkleL_5[0]",
                 "values":[
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                 ],
                 "answer":"5"
              },
           ]
         }
         
      ],
      "rules": [
        {
           "label":"Muscle Strength-Rate Scale",
           "legend":"muscleStrengthScale",
           "title":".",
           "subMain":"",
           "sub":"",
           "options":[
              {
                 "main":"No Muscle Movement",
                 "sub":"0/5"
              },
              {
                 "main":"Visible Muscle Contraction but No Joint Movement",
                 "sub":"1/5"
              },
              {
                 "main":"No movement against gravity",
                 "sub":"2/5"
              },
              {
                 "main":"No movement against resistance",
                 "sub":"3/5"
              },
              {
                 "main":"Less than normal strength",
                 "sub":"4/5"
              },
              {
                 "main":"Normal Strength",
                 "sub":"5/5"
              }
           ]
        }
      ]
   },
   {
      "question":"Deep tendon reflexes (DTRs) - Rate reflexes according to the scale",
      "sub":"",
      "type":"select",
      "show": true,
      "section": {
         page: "3",
         title: "NEUROLOGIC EXAM",
         number: "4B"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Biceps",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_2[0].BicepsR_0[0],F[0].Page_2[0].BicepsR_1[0],F[0].Page_2[0].BicepsR_2[0],F[0].Page_2[0].BicepsR_3[0],F[0].Page_2[0].BicepsR_4[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               },
               {
                 "main":"Triceps",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "2+",
                 "dbqName":  "F[0].Page_2[0].TricepsR_0[0],F[0].Page_2[0].TricepsR_1[0],F[0].Page_2[0].TricepsR_2[0],F[0].Page_2[0].TricepsR_3[0],F[0].Page_2[0].TricepsR_4[0]",
                 "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                 "main":"Brachioradialis",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "2+",
                 "dbqName":  "F[0].Page_2[0].BrachR_0[0],F[0].Page_2[0].BrachR_1[0],F[0].Page_2[0].BrachR_2[0],F[0].Page_2[0].BrachR_3[0],F[0].Page_2[0].BrachR_4[0]",
                 "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                "main":"Knee",
                "sub":"",
                "type":"check",
                "defaultVal": "2+",
                 "dbqName":  "F[0].Page_2[0].KneeR_0p[0],F[0].Page_2[0].KneeR_1plus[0],F[0].Page_2[0].KneeR_2plus[0],F[0].Page_2[0].KneeR_3plus[0],F[0].Page_2[0].KneeR_4plus[0]",
                "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                  "main":"Ankle",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_2[0].AnkleR_0p[0],F[0].Page_2[0].AnkleR_1plus[0],F[0].Page_2[0].AnkleR_2plus[0],F[0].Page_2[0].AnkleR_3plus[0],F[0].Page_2[0].AnkleR_4plus[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               }
            ]
         },
         {
           "label":"Flexion/Extension",
           "title":"Left Side",
           "subMain":"Rate Strength",
           "sub":"",
           "options":[
               {
                  "main":"Biceps",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_2[0].BicepsL_0[0],F[0].Page_2[0].BicepsL_1[0],F[0].Page_2[0].BicepsL_2[0],F[0].Page_2[0].BicepsL_3[0],F[0].Page_2[0].BicepsL_4[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               },
               {
               "main":"Triceps",
               "sub":"",
               "type":"check",
               "defaultVal": "2+",
               "dbqName": "F[0].Page_2[0].TricepsL_0[0],F[0].Page_2[0].TricepsL_1[0],F[0].Page_2[0].TricepsL_2[0],F[0].Page_2[0].TricepsL_3[0],F[0].Page_2[0].TricepsL_4[0]",
               "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
               "main":"Brachioradialis",
               "sub":"",
               "type":"check",
               "defaultVal": "2+",
               "dbqName": "F[0].Page_2[0].BrachL_0[0],F[0].Page_2[0].BrachL_1[0],F[0].Page_2[0].BrachL_2[0],F[0].Page_2[0].BrachL_3[0],F[0].Page_2[0].BrachL_4[0]",
               "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
               "main":"Knee",
               "sub":"",
               "type":"check",
               "defaultVal": "2+",
               "dbqName": "F[0].Page_2[0].KneeL_0p[0],F[0].Page_2[0].KneeL_1plus[0],F[0].Page_2[0].KneeL_2plus[0],F[0].Page_2[0].KneeL_3plus[0],F[0].Page_2[0].KneeL_4plus[0]",
               "values":[
                  "0",
                  "1+",
                  "2+",
                  "3+",
                  "4+"
               ],
               "answer":"2+"
               },
               {
                  "main":"Ankle",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "2+",
                  "dbqName": "F[0].Page_2[0].AnkleL_0p[0],F[0].Page_2[0].AnkleL_1plus[0],F[0].Page_2[0].AnkleL_2plus[0],F[0].Page_2[0].AnkleL_3plus[0],F[0].Page_2[0].AnkleL_4plus[0]",
                  "values":[
                     "0",
                     "1+",
                     "2+",
                     "3+",
                     "4+"
                  ],
                  "answer":"2+"
               }
           ]
        }
         
      ],
      "rules": [
         {
            "label":"Deep Tendon Reflex (DTR) Scale",
            "legend": "reflexExamScale",
            "options":[
               {
                  "main":"0",
                  "sub":"Absent"
               },
               {
                  "main":"1+",
                  "sub":"Decreased"
               },
               {
                  "main":"2+",
                  "sub":"Normal"
               },
               {
                  "main":"3+",
                  "sub":"Increased without clonus"
               },
               {
                  "main":"4+",
                  "sub":"Increased with clonus"
               }
            ]
         }
       ]
   },
   {
      "question":"Light touch/monofilament testing results",
      "sub":"",
      "type":"select",
      "show": true,
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Shoulder Area",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal1[2],F[0].Page_2[0].Decreased1[0],F[0].Page_2[0].Absent1[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Inner/Outer Forearm",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_2[0].Normal3[0],F[0].Page_2[0].Decreased3[0],F[0].Page_2[0].Absent3[0]",
                 "values":[
                  "Normal",
                  "Decreased",
                  "Absent"
               ],
                  "answer":"Normal"
               },
               {
                 "main":"Hand/Fingers",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_2[0].Normal5[0],F[0].Page_2[0].Decreased5[0],F[0].Page_2[0].Absent5[0]",
                 "values":[
                  "Normal",
                  "Decreased",
                  "Absent"
               ],
                  "answer":"Normal"
               },
               {
                  "main":"Knee/Thigh",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal7[0],F[0].Page_2[0].Decreased7[0],F[0].Page_2[0].Absent7[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Ankle/Lower Leg",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_2[0].Normal9[0],F[0].Page_2[0].Decreased9[0],F[0].Page_2[0].Absent9[0]",
                 "values":[
                  "Normal",
                  "Decreased",
                  "Absent"
               ],
                  "answer":"Normal"
               },
               {
                  "main":"Foot/Toes",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal11[0],F[0].Page_2[0].Decreased11[0],F[0].Page_2[0].Absent11[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               }
            ]
         },
         {
           "label":"Flexion/Extension",
           "title":"Left Side",
           "subMain":"Rate Strength",
           "sub":"",
           "options":[
               {
                  "main":"Shoulder Area",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal2[0],F[0].Page_2[0].Decreased2[0],F[0].Page_2[0].Absent2[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
               "main":"Inner/Outer Forearm",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal",
               "dbqName":"F[0].Page_2[0].Normal4[0],F[0].Page_2[0].Decreased4[0],F[0].Page_2[0].Absent4[0]",
               "values":[
                  "Normal",
                  "Decreased",
                  "Absent"
               ],
                  "answer":"Normal"
               },
               {
               "main":"Hand/Fingers",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal",
               "dbqName":"F[0].Page_2[0].Normal6[0],F[0].Page_2[0].Decreased6[0],F[0].Page_2[0].Absent6[0]",
               "values":[
                  "Normal",
                  "Decreased",
                  "Absent"
               ],
                  "answer":"Normal"
               },
               {
                  "main":"Knee/Thigh",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal8[0],F[0].Page_2[0].Decreased8[0],F[0].Page_2[0].Absent8[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
               "main":"Ankle/Lower Leg",
               "sub":"",
               "type":"check",
               "defaultVal": "Normal",
               "dbqName":  "F[0].Page_2[0].Normal10[0],F[0].Page_2[0].Decreased10[0],F[0].Page_2[0].Absent10[0]",
               "values":[
                  "Normal",
                  "Decreased",
                  "Absent"
               ],
                  "answer":"Normal"
               },
               {
                  "main":"Foot/Toes",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal12[0],F[0].Page_2[0].Decreased12[0],F[0].Page_2[0].Absent12[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               }
           ]
        }         
      ]
   },

   {
      "question":"Position index",
      "sub":"Grasp index finger/great toe on sides and ask patient to identify up and down movement",
      "type":"select",
      "show": true,
      "section": {
         page: "3",
         title: "NEUROLOGIC EXAM",
         number: "4D"
      },
      "questions":[
         {
            "label":"Position index",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal13[0],F[0].Page_2[0].Decreased13[0],F[0].Page_2[0].Absent13[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_2[0].Normal15[0],F[0].Page_2[0].Decreased15[0],F[0].Page_2[0].Absent15[0]",
                 "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
            ]
         },
         {
            "label":"Position index",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_2[0].Normal14[0],F[0].Page_2[0].Decreased14[0],F[0].Page_2[0].Absent14[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_2[0].Normal16[0],F[0].Page_2[0].Decreased16[0],F[0].Page_2[0].Absent16[0]",
                 "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
            ]
         },         
      ]
   },
   {
      "question":"Vibration sensation",
      "sub":"Place low-pitched tuning fork over DIP joint of index finger/IP joint of great toe",
      "type":"select",
      "show": true,
      "section": {
         page: "4",
         title: "NEUROLOGIC EXAM",
         number: "4E"
      },
      "questions":[
         {
            "label":"Vibration sensation",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_3[0].Normal17[0],F[0].Page_3[0].Decreased17[0],F[0].Page_3[0].Absent17[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_3[0].Normal19[0],F[0].Page_3[0].Decreased19[0],F[0].Page_3[0].Absent19[0]",
                 "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
            ]
         },
         {
            "label":"Vibration sensation",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_3[0].Normal18[0],F[0].Page_3[0].Decreased18[0],F[0].Page_3[0].Absent18[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_3[0].Normal20[0],F[0].Page_3[0].Decreased20[0],F[0].Page_3[0].Absent20[0]",
                 "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
            ]
         },         
      ]
   },
   {
      "question":"Cold sensation",
      "sub":"Test distal extremities for cold sensation with side of tuning fork",
      "type":"select",
      "show": true,
      "section": {
         page: "4",
         title: "NEUROLOGIC EXAM",
         number: "4F"
      },
      "questions":[
         {
            "label":"Cold sensation",
            "title":"Right Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_3[0].Normal21[0],F[0].Page_3[0].Decreased21[0],F[0].Page_3[0].Absent21[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_3[0].Normal23[0],F[0].Page_3[0].Decreased23[0],F[0].Page_3[0].Absent23[0]",
                 "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
            ]
         },
         {
            "label":"Cold sensation",
            "title":"Left Side",
            "subMain":"Severity",
            "sub":"",
            "options":[
               {
                  "main":"Upper Extremity",
                  "sub":"",
                  "type":"check",
                  "defaultVal": "Normal",
                  "dbqName": "F[0].Page_3[0].Normal22[0],F[0].Page_3[0].Decreased22[0],F[0].Page_3[0].Absent22[0]",
                  "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
               {
                 "main":"Lower Extremity",
                 "sub":"",
                 "type":"check",
                 "defaultVal": "Normal",
                 "dbqName":  "F[0].Page_3[0].Normal24[0],F[0].Page_3[0].Decreased24[0],F[0].Page_3[0].Absent24[0]",
                 "values":[
                     "Normal",
                     "Decreased",
                     "Absent"
                  ],
                  "answer":"Normal"
               },
            ]
         },         
      ]
   },

   {
      "question":"Does ##name## have an upper extremity (##redHeading##) diabetic peripheral neuropathy?",
      "redHeading": "radial nerve",
      "sub":"If Yes, indicate nerve affected, severity and side affected",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "note":'For VA purposes, the term "incomplete paralysis" indicates a degree of lost or impaired function substantially less than the description of complete paralysis that is given with each nerve. If the nerve is completely paralyzed, check the box for "complete paralysis". If the nerve is not completely paralyzed, check the box for "incomplete paralysis" and indicate severity. For VA purposes, when nerve impairment is wholly sensory, the evaluation should be mild, or at most, moderate.',
      "section": {
         page: "4",
         title: "SEVERITY",
         number: "5A"
      },
      "questions":[
               {
                  "main":"Radial nerve (musculospiral nerve)",
                  "dbqName":"F[0].Page_3[0].Nerve[0],F[0].Page_3[0].Yes5[0]",
                  "heading" : "Right",
                  "answer":"",
                  "multi": false,
                  "note": "Complete paralysis (hand and fingers drop, wrist and fingers flexed; cannot extend hand at wrist, extend proximal phalanges of fingers, extend thumb or make lateral movement of wrist; supination of hand, elbow extension and flexion weak, hand grip impaired.)",
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_3[0].Mild2[0],F[0].Page_3[0].Mild1[0]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_3[0].Moderate2[0],F[0].Page_3[0].Mild1[0]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_3[0].Severe2[0],F[0].Page_3[0].Mild1[0]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_3[0].Paresthesias1[0]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_3[0].Dull1[0]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_3[0].Constant1[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },
               {
                  "main":"Radial nerve (musculospiral nerve)",
                  "dbqName":"F[0].Page_3[0].Nerve[0]",
                  "heading" : "Left",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_3[0].Mild2[1],F[0].Page_3[0].MedianNerve[0]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_3[0].Moderate2[1],F[0].Page_3[0].MedianNerve[0]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_3[0].Severe2[1],F[0].Page_3[0].MedianNerve[0]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_3[0].Paresthesias1[1]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_3[0].Dull1[1]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_3[0].Constant1[1]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },              
            ]
   },
   {
      "question":"Does ##name## have an upper extremity (##redHeading##) diabetic peripheral neuropathy?",
      "redHeading": "median nerve",
      "sub":"If Yes, indicate nerve affected, severity and side affected",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "note":'For VA purposes, the term "incomplete paralysis" indicates a degree of lost or impaired function substantially less than the description of complete paralysis that is given with each nerve. If the nerve is completely paralyzed, check the box for "complete paralysis". If the nerve is not completely paralyzed, check the box for "incomplete paralysis" and indicate severity. For VA purposes, when nerve impairment is wholly sensory, the evaluation should be mild, or at most, moderate.',
      "section": {
         page: "4",
         title: "SEVERITY",
         number: "5A"
      },
      "questions":[
               {
                  "main":"Median Nerve",
                  "dbqName":"F[0].Page_3[0].Nerve[1],F[0].Page_3[0].Yes5[0]",
                  "heading" : "Right",
                  "answer":"",
                  "multi": false,
                  "note": "Complete paralysis (hand inclined to the ulnar side, index and middle fingers extended, atrophy of thenar eminence, cannot make fist, defective opposition of thumb, cannot flex distal phalanx of thumb; wrist flexion weak.)",
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_3[0].Mild2[2],F[0].Page_3[0].Mild1[1]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_3[0].Moderate2[2],F[0].Page_3[0].Mild1[1]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_3[0].Severe2[2],F[0].Page_3[0].Mild1[1]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_3[0].Paresthesias1[2]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_3[0].Dull1[2]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_3[0].Constant1[2]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },
               {
                  "main":"Median Nerve",
                  "dbqName":"F[0].Page_3[0].Nerve[0]",
                  "heading" : "Left",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_3[0].Mild2[3],F[0].Page_3[0].Mild1[2]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_3[0].Moderate2[3],F[0].Page_3[0].Mild1[2]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_3[0].Severe2[3],F[0].Page_3[0].Mild1[2]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_3[0].Paresthesias1[3]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_3[0].Dull1[3]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_3[0].Constant1[3]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },              
            ]
   },
   {
      "question":"Does ##name## have an upper extremity (##redHeading##) diabetic peripheral neuropathy?",
      "redHeading": "ulnar nerve",
      "sub":"If Yes, indicate nerve affected, severity and side affected",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "note":'For VA purposes, the term "incomplete paralysis" indicates a degree of lost or impaired function substantially less than the description of complete paralysis that is given with each nerve. If the nerve is completely paralyzed, check the box for "complete paralysis". If the nerve is not completely paralyzed, check the box for "incomplete paralysis" and indicate severity. For VA purposes, when nerve impairment is wholly sensory, the evaluation should be mild, or at most, moderate.',
      "section": {
         page: "4",
         title: "SEVERITY",
         number: "5A"
      },
      "questions":[
               {
                  "main":"Ulnar Nerve",
                  "dbqName":"F[0].Page_3[0].Nerve[2],F[0].Page_3[0].Yes5[0]",
                  "heading" : "Right",
                  "answer":"",
                  "multi": false,
                  "note": 'Complete paralysis ("griffin claw" deformity, atrophy in dorsal interspaces, thenar and hypothenar eminences; cannot extend ring and little finger, cannot spread fingers, cannot adduct the thumb; wrist flexion weakened.)',
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_3[0].Mild2[4],F[0].Page_3[0].Mild1[3]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_3[0].Moderate2[4],F[0].Page_3[0].Mild1[3]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_3[0].Severe2[4],F[0].Page_3[0].Mild1[3]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_3[0].Paresthesias1[4]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_3[0].Dull1[4]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_3[0].Constant1[4]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },
               {
                  "main":"Ulnar Nerve",
                  "dbqName":"F[0].Page_3[0].Nerve[2],F[0].Page_3[0].Yes5[0]",
                  "heading" : "Left",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_3[0].Mild2[5],F[0].Page_3[0].Mild1[4]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_3[0].Moderate2[5],F[0].Page_3[0].Mild1[4]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_3[0].Severe2[5],F[0].Page_3[0].Mild1[4]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_3[0].Paresthesias1[5]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_3[0].Dull1[5]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_3[0].Constant1[5]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },              
            ]
   },

   {
      "question":"Does ##name## have an lower extremity (##redHeading##) diabetic peripheral neuropathy?",
      "redHeading": "sciatic nerve",
      "sub":"If Yes, indicate nerve affected, severity and side affected, otherwise you can click next",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "optional": true,
      "cols": 2,
      "note":'For VA purposes, the term "incomplete paralysis" indicates a degree of lost or impaired function substantially less than the description of complete paralysis that is given with each nerve. If the nerve is completely paralyzed, check the box for "complete paralysis". If the nerve is not completely paralyzed, check the box for "incomplete paralysis" and indicate severity. For VA purposes, when nerve impairment is wholly sensory, the evaluation should be mild, or at most, moderate.',
      "section": {
         page: "5",
         title: "SEVERITY",
         number: "5B"
      },
      "questions":[
               {
                  "main":"Sciatic Nerve",
                  "dbqName":"F[0].Page_4[0].Nerve[0],F[0].Page_4[0].Yes6[0]",
                  "heading" : "Right",
                  "answer":"",
                  "multi": false,
                  // "note": 'Complete paralysis ("griffin claw" deformity, atrophy in dorsal interspaces, thenar and hypothenar eminences; cannot extend ring and little finger, cannot spread fingers, cannot adduct the thumb; wrist flexion weakened.)',
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_4[0].Mild2[0],F[0].Page_4[0].Mild1[3]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_4[0].Moderate2[0],F[0].Page_4[0].Mild1[3]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_4[0].Severe2[0],F[0].Page_4[0].Mild1[3]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_4[0].Mild3[0]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_4[0].Moderate3[0]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_4[0].Severe3[0]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },
               {
                  "main":" Sciatic Nerve",
                  "dbqName":"F[0].Page_4[0].Nerve[0],F[0].Page_4[0].Yes6[0]",
                  "heading" : "Left",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_4[0].Mild2[1],F[0].Page_4[0].Mild1[0]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_4[0].Moderate2[1],F[0].Page_4[0].Mild1[0]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_4[0].Severe2[1],F[0].Page_4[0].Mild1[0]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_4[0].Mild3[1]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_4[0].Moderate3[1]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_4[0].Severe3[1]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               }        
            ]
   },
   {
      "question":"Does ##name## have an lower extremity (##redHeading##) diabetic peripheral neuropathy?",
      "redHeading": "femoral nerve",
      "sub":"If Yes, indicate nerve affected, severity and side affected, otherwise you can click next",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "optional": true,
      "cols": 2,
      "note":'For VA purposes, the term "incomplete paralysis" indicates a degree of lost or impaired function substantially less than the description of complete paralysis that is given with each nerve. If the nerve is completely paralyzed, check the box for "complete paralysis". If the nerve is not completely paralyzed, check the box for "incomplete paralysis" and indicate severity. For VA purposes, when nerve impairment is wholly sensory, the evaluation should be mild, or at most, moderate.',
      "section": {
         page: "5",
         title: "SEVERITY",
         number: "5B"
      },
      "questions":[
               {
                  "main":"Femoral Nerve",
                  "dbqName":"F[0].Page_4[0].Nerve[1],F[0].Page_4[0].Yes6[0]",
                  "heading" : "Right",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_4[0].Mild2[2],F[0].Page_4[0].Mild1[1]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_4[0].Moderate2[2],F[0].Page_4[0].Mild1[1]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_4[0].Severe2[2],F[0].Page_4[0].Mild1[1]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_4[0].Mild3[2]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_4[0].Moderate3[2]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_4[0].Severe3[2]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               },
               {
                  "main":" Femoral Nerve",
                  "dbqName":"F[0].Page_4[0].Nerve[1],F[0].Page_4[0].Yes6[0]",
                  "heading" : "Left",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Normal",
                        "dbqName":"F[0].Page_4[0].Mild2[3],F[0].Page_4[0].Mild1[2]",
                        "colWidth": "3",
                        "answer":""
                     },
                     {
                        "main":"Incomplete paralysis",
                        "dbqName":"F[0].Page_4[0].Moderate2[3],F[0].Page_4[0].Mild1[2]",
                        "colWidth": "5",
                        "subItem3Linked": true,
                        "answer":""
                     },
                     {
                        "main":"Complete paralysis",
                        "dbqName":"F[0].Page_4[0].Severe2[3],F[0].Page_4[0].Mild1[2]",
                        "answer":""
                     },                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Indicate severity",
                  "showSubItems3": false,
                  "subItems3": [
                     {
                        "main":"Mild",
                        "dbqName":"F[0].Page_4[0].Mild3[3]",
                        "answer":""
                     },
                     {
                        "main":"Moderate",
                        "dbqName":"F[0].Page_4[0].Moderate3[3]",
                        "answer":""
                     },
                     {
                        "main":"Severe",
                        "dbqName":"F[0].Page_4[0].Severe3[3]",
                        "answer":""
                     }
                  ],
                  "subAnswer3":"",
                  "subItems3Label" :"Indicate severity",
               }        
            ]
   },

   {
      "question":"Does ##name##'s diabetic peripheral neuropathy impact his or her ability to work?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "6",
         title: "FUNCTIONAL IMPACT",
         number: "8"
      },
      "maxLength":800,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].#subform[5].Yes9[0]",
      "dbqName_no":"F[0].#subform[5].No9[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe impact of the veteran's diabetic peripheral neuropathy, providing one or more examples",
      "textdbqName":"F[0].#subform[5].Describe1[0]",
      "textanswer":""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "maxLength":1850,
      "presidence":"Yes",
      "type":"textarea",
      "show": true,
      "dbqName":"F[0].#subform[5].Remarks[0]",
      "answer":""
   }
 ]

 export default nerves_questions ;
